<template>
  <div class="ex-home">
    <div class="eh-top">
      <div class="eh-top-l">
        <div class="info">
          <div class="info-title">{{exhibition.name}}</div>
          <div class="info-txt">成功参展你还需要完成以下项目</div>
        </div>
      </div>
      <div class="eh-top-r">
        <div  class="header-tool-box">
            <div class="htb-item" @click="$router.go(-1)">
            <span>返回</span>
            </div>
        </div>
      </div>
    </div>
    <div class="eh-content">
      <Row :gutter="30" v-if="ComFinish.length">
        <Col
          :md="12"
          :xl="8"
          :xxl="6"
          v-for="(item, index) in ComFinish"
          :key="'releaseInt-' + index"
          class="w-20"
        > 
          <!-- 会刊信息 -->
          <div class="pro" :class="item.stateId !== 1 ? 'pro-no' :'pro-over'">
            <div class="pro-top" @click="linkToOthers(item)">
              {{item.name}}
              <span v-if="item.stateId == 1" style="color: #009944;">已完成</span>
              <span v-if="item.stateId == -1" style="color: #999;">待完成</span>
              <span v-if="item.stateId == 0" style="color: #fe781d;">进行中</span>
            </div>
            <div class="pro-bot common-bot">
              <p>
                {{item.introduction}}
                <span class="exist" v-if="item.link" @click="linkTo(item.link)">查看详情</span>
              </p>
              <span class="type-1" v-if="item.stateId == 1">
                  <img src="@/assets/img/home-over.png" alt="">
              </span>
              <span class="type-3" v-if="item.stateId == 1">将展示在【我的云店】中</span>
              <span class="type-2" v-if="item.stateId !== 1 && item.stopTime">{{item.stopTime | moment("YYYY/MM/DD")}}截止</span>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import {  mapGetters } from "vuex";
export default {
  name: "exhibition-home-project",
  data() {
    return {
      ComFinish:[],
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo"
    }),
    header() { return this.$store.state.header},
  }, 
  mounted(){
    this.getComFinish();
  },
  methods:{
    getComFinish(){ // 获取获取公司确认项
      this.$http.get(`/api/join/GetFinishItems?joinId=${this.joinInfo.joinId}`,this.header)
                .then(res=>{
                  if(res.status === 200 && res.data){
                    this.ComFinish = res.data.items;
                    this.ComFinish.map(c => {
                      if (c.introduction.length > 80) {
                        c.introduction = c.introduction.substring(0,80) + '...';
                      }
                    })
                  }
                })
    },
    linkTo(item) {
      window.open(item);
    },
    linkToOthers(item) {
      // 根据finishType字段，跳转至不同页面
      // Embellish = 11：个性化设置提示
      // Release = 12：发布商机提示
      // Product = 13：上传产品提示
      // Activity = 14：申请活动提示
      // Catalogue = 15：提交会刊提示
      // Lintel = 16：提交楣板信息提示, 
      // Vehicle = 17：申请车证提示
      // Company = 18：完善公司信息提示
      // Contact = 19：完善联系人提示
      // Invoice = 20：完善开票信息提示
      // Example = 21：上传案例提示
      // Brand = 22：上传品牌提示
      // Cooperation = 23：上传合作伙伴提示
      if (item.finishType) {
        switch (item.finishType) {
          case 11:
            this.$router.push("/exhibition/index/exinfo/exhibition-info");
            break;
          case 12: // 商机
            break;
          case 13:
            this.$router.push("/exhibition/index/product/allpro");
            break;
          case 14:
            this.$router.push("/exhibition/index/activity/allpro");
            break;
          case 15:
            this.$router.push("/exhibition/index/exinfo/catalogue");
            break;
          case 16:
            this.$router.push("/exhibition/index/exinfo/fascia-board");
            break;
          case 17:
            this.$router.push("/exhibition/index/exinfo/carApply");
            break;
          case 18:
            this.$router.push("/exhibition/index/companyInfo?type=basic");
            break;
          case 19:
            this.$router.push("/exhibition/index/companyInfo?type=link");
            break;
          case 20:
            this.$router.push("/exhibition/index/exinfo/invoice");
            break;
          case 21:
            this.$router.push("/exhibition/index/case/all");
            break;
          case 22:
            this.$router.push("/exhibition/index/brand/allbrand");
            break;
          case 23:
            this.$router.push("/exhibition/index/partner/allpartner");
            break;
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.ex-home {
  width: 100%;
	height: 120px;
	background-color: #fff;
	box-shadow: 0px 0px 5px 0px 
		rgba(0, 0, 0, 0.1);
  padding:20px 24px 0 24px ;
  .eh {
    &-top {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      &-l {
        width: 60%;
        display: flex;
        align-items: center;
        .logo {
          width: 64px;
          height: 64px;
          border: 1px solid #d8d8d8;
          border-radius: 5px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .info {
          position: relative;
          max-width: calc(100% - 100px);
          &-title {
            font-size: 14px;
            color: #333;
            font-weight: bold;
            margin-bottom: 10px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &-txt {
            font-size: 12px;
            color: #4d4d4d;
          }
          span{
            position: absolute;
            right: -40px;
            top:4px;
            font-size: 14px;
            color: #d13119;
            cursor: pointer;
          }
        }
      }
      &-r {
        position: relative;
        width: 40%;
        text-align: right;
        .htb-item{
            display: flex;
            width: 150px;
            height: 80px;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            border: 2px dotted #d13119;
            color: #d13119;
            background: #ffe6e3;
            margin-left: 20px;
            cursor: pointer;
        }
      }
    }
    &-content {
      padding-top:24px;
      .pro{
        height: 260px;
        background-color: #fafafa;
        box-shadow: 0px 2px 6px 0px 
          rgba(136, 156, 176, 0.1);
        margin-bottom: 24px;
      }
      .pro-no{
        background-color: #fff;
        .pro-top{
            color:#333;
        }
        .common-bot{
            p{
                color:#333;
            }
        }
      }
      .pro-top{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 52px;
        font-size: 16px;
        color: #999;
        padding: 0 24px;
        border-bottom: 1px solid #e8e8e8;
        cursor: pointer;
        span{
          display: block;
          color: #009944;
          font-size: 16px;
        }
      }
      .pro-bot{
        padding:12px 24px 24px 24px;
        height: 208px;
      }
      .common-bot{
        position: relative;
        p{
          max-height: 132px;
          font-size: 14px;
          color: #999;
          // font-weight: bold;
          line-height: 2;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 4;
          // -webkit-box-orient: vertical;
        }
        .type-1{
          position: absolute;
          right: 10px;
          bottom: 10px;
        }
        .type-2{
          position: absolute;
          right: 20px;
          bottom: 10px;
          color: #ff0000;
        }
        .type-3 {
          width: 100%;
          text-align: center;
          position: absolute;
          left: 0;
          bottom: 10px;
          color: #333;
        }
      }
    }
  }
  .exist {
    font-size: 14px;
    color: #1890ff;
    // margin-left: 10px;
    z-index: 1000;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
